export function siteIsLoaded() {
	document.body.classList.add('loaded');
}